import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import CreateTemplatesIcon from "../../../assets/AdsGeneration/icons/ad-gen-create-templates.svg";
import DefineBrandIcon from "../../../assets/AdsGeneration/icons/ad-gen-define-brands.svg";
import DemoIcon from "../../../assets/AdsGeneration/icons/ad-gen-demo.svg";
import copyApiImage from "../../../assets/AdsGeneration/images/ads-generation-overview.png";
import IframeIcon from "../../../assets/common/icons/enable-iframe.svg";
import APIIcon from "../../../assets/common/icons/integrate-api.svg";
import ConsoleOverviewCards, { OverviewCardType } from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import RouterConstants from "../../../constants/RouterConstants";

const AdsGenerationOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "adsGeneration.overview" });

	const cards: OverviewCardType[] = [
		{
			icon: DefineBrandIcon,
			title: t("cards.defineBrand.title"),
			description: t("cards.defineBrand.description"),
			link: RouterConstants.ADS_GENERATION.BRANDS_TEMPLATES.fullPath,
		},
		{
			icon: CreateTemplatesIcon,
			title: t("cards.createTemplates.title"),
			description: t("cards.createTemplates.description"),
			link: RouterConstants.ADS_GENERATION.BRANDS_TEMPLATES.fullPath,
		},
		{
			icon: DemoIcon,
			title: t("cards.demo.title"),
			description: t("cards.demo.description"),
			link: RouterConstants.ADS_GENERATION.DEMO.fullPath,
		},
		{
			icon: APIIcon,
			title: t("cards.api.title"),
			description: t("cards.api.description"),
			link: RouterConstants.ADS_GENERATION.API.fullPath,
		},
		{
			icon: IframeIcon,
			title: t("cards.iframe.title"),
			description: t("cards.iframe.description"),
			link: RouterConstants.ACCOUNT_IFRAMES.fullPath,
			newTab: true,
		},
	];

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
			}}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(AdsGenerationOverview);
